import React, { useEffect, useMemo, useState } from 'react';
import { toast } from 'react-toastify';

import { isArray, isEmpty, isNull } from 'lodash';
import moment from 'moment';

import { Report } from '~/components';
import {
  Autocomplete,
  DateTime,
  RadioGroup,
  MultiAutocomplete,
  Select,
} from '~/components/Form';
import { PesquisaTabela } from '~/components/Form/v2';
import { t } from '~/helpers';

function Relalteracaomodooperacional() {
  const [open, setOpen] = useState(true);

  const [posto, setPosto] = useState(0);
  const [valuePosto, setValuePosto] = React.useState(0);
  const [inputValuePosto, setInputValuePosto] = React.useState('');

  const [bico, setBico] = useState(0);
  const [valueBico, setValueBico] = React.useState(0);
  const [inputValueBico, setInputValueBico] = React.useState('');

  const [justificativa, setJustificativa] = useState(0);
  const [valueJustificativa, setValueJustificativa] = React.useState(0);
  const [inputValueJustificativa, setInputValueJustificativa] = React.useState(
    ''
  );

  const start = moment()
    .subtract({ day: 7 })
    .set({ hour: 0, minute: 0, second: 0 });

  const end = moment().set({ hour: 23, minute: 59, second: 59 });

  const cellsUser = useMemo(
    () => [
      {
        id: 'codigousuario',
        label: t('s.cadastro.usuario.codigousuario'),
        filter: { type: 'text' },
      },
      {
        id: 'nomeusuario',
        label: t('s.cadastro.usuario.nomeusuario'),
        filter: { type: 'text' },
      },
    ],
    []
  );

  const orderoptions = [
    { value: 'LI', label: t('s.relatorio.abastecimento.opcaolistagem') },
    { value: 'BI', label: t('s.relatorio.abastecimento.opcaobico') },
    { value: 'DT', label: t('s.relatorio.abastecimento.opcaodata') },
    { value: 'FT', label: t('s.relatorio.abastecimentolistagem.frentista') },
    {
      value: 'JF',
      label: t('s.relatorio.alteracaomodooperacional.justificativa'),
    },
    { value: 'PC', label: t('s.relatorio.abastecimento.opcaopostocomboio') },
  ];

  function handleSerializeForm(params) {
    const idPosto =
      valuePosto === 0 ? '' : valuePosto?.map((posto) => posto.idposto);
    const idBico = valueBico === 0 ? '' : valueBico;
    const descricaoJustificativa =
      valueJustificativa === 0 ? '' : inputValueJustificativa;

    return {
      ...params,
      idposto: idPosto,
      idbico: idBico,
      descricaojustificativa: descricaoJustificativa,
    };
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title={t('s.relatorio.alteracaomodooperacional')}
      relatorio="alteracaomodooperacional"
      serialize={(param) => handleSerializeForm(param)}
      initials={{
        datahorainicial: start.format('DD/MM/YYYY HH:mm:ss'),
        datahorafinal: end.format('DD/MM/YYYY HH:mm:ss'),
        idjustificativa: '0',
        idperfilrelatorio: '0',
        tipoordenacaoreport: 'LI',
      }}
    >
      <DateTime
        label={t('s.geral.opcoes.datahorainicial')}
        name="datahorainicial"
        serialize={(value) =>
          value.set({ second: 0 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <DateTime
        label={t('s.geral.opcoes.datahorafinal')}
        name="datahorafinal"
        serialize={(value) =>
          value.set({ second: 59 }).format('DD/MM/YYYY HH:mm:ss')
        }
        time
      />

      <MultiAutocomplete
        multiple
        name="idposto"
        label="codigonomeposto"
        url="postoscomboios"
        unique="idposto"
        title={t('s.geral.postocomboio')}
        hiddens={[{ name: 'codigonomeposto' }]}
        getValue={(value) => {
          if (value[0]?.idposto === null) {
            setValuePosto(0);
            setInputValuePosto('');

            setValueBico(0);
            setInputValueBico('');

            setPosto(0);
            setBico(0);
          } else {
            setValuePosto(value);
            setPosto(value);

            setValueBico(0);
            setInputValueBico('');
          }
        }}
      />

      <Autocomplete
        name="idbico"
        label="bicoprodutobico"
        url="bicos"
        unique="idbico"
        title={t('s.menu.configuracao.bico')}
        value={valueBico}
        inputValue={inputValueBico}
        onChange={(event, newValue) => {
          setValueBico(newValue);
        }}
        onInputChange={(event, newInputValueBico) => {
          setInputValueBico(newInputValueBico);
        }}
        disabled={valuePosto.length === 0 || valuePosto.length > 1}
        getValue={(value) => {
          setValueBico(value.idbico);

          if (value.idbico === null) {
            setBico(0);
          } else {
            setBico(value.idbico);
          }
        }}
        params={{
          wherefield: 'idposto',
          valuewherefield: valuePosto[0]?.idposto,
          typewherefield: 'EQUALS',
        }}
      />

      <PesquisaTabela
        name="frentista"
        label={t('s.relatorio.abastecimentocontingencia.frentista')}
        primary="codigousuario"
        secondary="nomeusuario"
        url="usuarios"
        header={cellsUser}
      />

      <Autocomplete
        name="descricaojustificativa"
        label="descricaojustificativatrocamodooperacional"
        url="justificativastrocasmodosoperacionals"
        unique="idjustificativatrocamodooperacional"
        title={t('s.relatorio.alteracaomodooperacional.justificativa')}
        value={valueJustificativa}
        inputValue={inputValueJustificativa}
        onChange={(event, newValue) => {
          setValueJustificativa(newValue);
        }}
        onInputChange={(event, newInputValueJustificativa) => {
          setInputValueJustificativa(newInputValueJustificativa);
        }}
        getValue={(value) => {
          setValueJustificativa(value.idjustificativa);

          if (value.idjustificativa === null) {
            setJustificativa(0);
          } else {
            setJustificativa(value.idjustificativa);
          }
        }}
      />

      <Select
        name="tipoordenacaoreport"
        variant="outlined"
        size="small"
        label={t('s.relatorio.abastecimento.tipoordenacao')}
        options={orderoptions}
      />

      <RadioGroup
        name="formato"
        label={t('s.relatorio.geral.formato')}
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'excel' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default Relalteracaomodooperacional;
